import $ from 'jquery';

$(document).ready(function() {
    $('header #search-toggler').click(function(e) {
        e.stopPropagation();
        $(this).toggleClass('open');
    })
    $('header input.search-field').click(function(e) {
        e.preventDefault();
        e.stopPropagation();
    })
    $('body').click(function() {
        $('header #search-toggler').removeClass('open');
    })
    $('.wpml-ls-item-toggle').click(function (e) {
        $(this).toggleClass('open');
    })
})